import React from 'react'
import {connect} from 'react-redux'
import {fromJS} from 'immutable'

import {
  GROUP_CHAT_SUBSCRIPTION_TYPES
} from './config/constants'

const {INSTANT, DAILY, WEEKLY} = GROUP_CHAT_SUBSCRIPTION_TYPES

import closeModal from './data/actions/close_modal'
import {subscribeGroupChat, unsubscribeGroupChat} from './data/setters/group_chat_subscription'

import ModalView from './modal_view'

class GroupChatSubscriptionModal extends React.Component {
  constructor (props) {
    super(props)

    this.closeModal = this.closeModal.bind(this)

    this.subscriptionActionAttrs = {
      [INSTANT]: {
        header: 'Instant',
        infoUnchecked: 'Get every message by email for this group chat when you are offline',
        infoChecked: 'You are getting every message by email for this group chat when you are offline'
      },
      [DAILY]: {
        header: 'Daily',
        infoUnchecked: 'Get daily digests by email for this group chat',
        infoChecked: 'You are getting daily digests by email for this group chat'
      },
      [WEEKLY]: {
        header: 'Weekly',
        infoUnchecked: 'Get weekly digests by email for this group chat',
        infoChecked: 'You are getting weekly digests by email for this group chat'
      }
    }

    this.renderSubscriptionRow = this.renderSubscriptionRow.bind(this)
  }

  toggleSubscription (type, isSubscribed) {
    if (isSubscribed) this.props.unsubscribeGroup(this.props.uid, this.props.groupId, type)
    else this.props.subscribeGroup(this.props.uid, this.props.groupId, type)
  }

  closeModal (e) {
    if (e) e.preventDefault()

    this.props.onCloseModal(this.props.modalKey)
  }

  renderBody () {
    if (!this.props.uid) {
      return (
        <div className='alert alert-warning warning'>
          You have to sign in to change subscription options.
        </div>
      )
    }
    else {
      return (
        <div className='alert alert-success success'>
          You can subscribe to any option below to be up to date for this group chat.
        </div>
      )
    }
  }

  renderSubscribedMark (isSubscribed) {
    if (!isSubscribed) return false

    return (
      <i className='rc-icon-check' style={{fontSize: 24}}/>
    )
  }

  renderSubscriptionRow (type) {
    const {header, infoUnchecked, infoChecked} = this.subscriptionActionAttrs[type]
    const isSubscribed = this.props.subscription.get(type)

    return (
      <div className='action-row' onClick={this.toggleSubscription.bind(this, type, isSubscribed)}>
        <div style={{display: 'table-cell', width: '100%'}}>
          <div style={{marginRight: 5}}>
            <h5 style={{marginTop: 0, marginBottom: 0, fontWeight: 'bold'}}>{header}</h5>
            <div style={{fontSize: 10, color: '#A0A0A0'}}>
              {isSubscribed ? infoChecked : infoUnchecked}
            </div>
          </div>
        </div>
        <div style={{display: 'table-cell', verticalAlign: 'middle', textAlign: 'right', color: '#259B24'}}>
          {this.renderSubscribedMark(isSubscribed)}
        </div>
      </div>
    )
  }

  renderSubscriptionRows () {
    if (!this.props.uid) return false

    return [INSTANT, DAILY, WEEKLY].map(this.renderSubscriptionRow)
  }

  renderActions () {
    return (
      <div className='actions stacked'>
        {this.renderSubscriptionRows()}
        <div className='cancel action-row' onClick={this.closeModal} style={{textAlign: 'center'}}>
          Close
        </div>
      </div>
    )
  }

  renderSecondaryHeader () {
    if (this.props.source === 'user' && this.props.uid) {
      return (
        <h6>For: {this.props.uid}</h6>
      )
    }
  }

  renderModalContent () {
    return (
      <div>
        <div className='modal-header'>
          <h4>Subscribe to Group Chat: {this.props.groupChat.get('name')}</h4>
          {this.renderSecondaryHeader()}
        </div>
        <div className='modal-body'>
          {this.renderBody()}
        </div>
        <div className='modal-footer no-padding'>
          {this.renderActions()}
        </div>
      </div>
    )
  }

  render () {
    return (
      <ModalView isActive={true} onClose={this.onClose}>
        {this.renderModalContent()}
      </ModalView>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  let uid, subscription

  if (ownProps.source === 'user') {
    uid = ownProps.uid
    subscription = state.getIn(['groups', '_subscriptions', 'groups', ownProps.groupId, uid], fromJS({}))
  }
  else {
    uid = state.getIn(['currentUser', 'uid'])
    subscription = state.getIn(['groups', '_subscriptions', 'users', uid, ownProps.groupId], fromJS({}))
  }

  return {
    groupChat: state.getIn(['groups', 'all', ownProps.groupId]),
    uid,
    subscription
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    subscribeGroup: subscribeGroupChat,
    unsubscribeGroup: unsubscribeGroupChat,
    onCloseModal: (modalKey) => dispatch(closeModal(modalKey))
  }
}

const GroupChatSubscriptionModalContainer = connect(
  mapStateToProps, mapDispatchToProps
)(GroupChatSubscriptionModal)

export default GroupChatSubscriptionModalContainer



/** WEBPACK FOOTER **
 ** ./modules/shared/group_chat_subscription_modal.js
 **/